import {
  IngredientDocAliasDTO,
  IngredientDocBufferDataPoint,
  IngredientDocCasNumberDTO,
  IIngredientDocDeletedData,
  IngredientDocInfo,
  IngredientDocStockDTO,
  IngredientDocumentDTO,
  IngredientTypeDTO,
  SaveIngredientDocDTO,
  IngredientDocDeletedData,
} from 'business/models/Models';
import { IngredientDocumentData } from 'redux/reducers/ingredientDetailReducer';
import { getModelArray, getModelObject, getPlainArray, getPlainObject } from './utils';

const getStocksPlainArray = (stocks: IngredientDocStockDTO[]) => {
  return stocks.map((li) => {
    const { ...stock } = getPlainObject(li);
    if (stock.vendor) {
      stock.vendor = getPlainObject(stock.vendor);
    }
    return stock;
  });
};

export const getIngredientDocPlainData = (
  modelObject: IngredientDocumentDTO,
): IngredientDocumentData => {
  return {
    info: getPlainObject(modelObject.info),
    types: getPlainArray(modelObject.types),
    aliases: getPlainArray(modelObject.aliases),
    casNumbers: getPlainArray(modelObject.casnumbers),
    stocks: getStocksPlainArray(modelObject.stocks),
    bufferDataPoint: getPlainArray(modelObject.bufferDataPoint),
  } as IngredientDocumentData;
};

export const getIngredientDocModelObject = (
  plainData: IngredientDocumentData,
  deletedData: IIngredientDocDeletedData,
): SaveIngredientDocDTO => {
  const ingredientDocData = new IngredientDocumentDTO();
  ingredientDocData.info = getModelObject(plainData.info, IngredientDocInfo);
  ingredientDocData.stocks = getModelArray(plainData.stocks, IngredientDocStockDTO);
  ingredientDocData.aliases = getModelArray(plainData.aliases, IngredientDocAliasDTO);
  ingredientDocData.bufferDataPoint = getModelArray(
    plainData.bufferDataPoint,
    IngredientDocBufferDataPoint,
  );
  ingredientDocData.types = getModelArray(plainData.types, IngredientTypeDTO);
  ingredientDocData.casnumbers = getModelArray(
    plainData.casNumbers,
    IngredientDocCasNumberDTO,
  );
  const deletedModel = new IngredientDocDeletedData();
  deletedModel.aliases = deletedData.aliases;
  deletedModel.bufferDataPoints = deletedData.bufferDataPoints;
  deletedModel.casNumbers = deletedData.casNumbers;
  deletedModel.stocks = deletedData.stocks;
  deletedModel.types = deletedData.types;

  const saveData = new SaveIngredientDocDTO();
  saveData.deletedData = deletedModel;
  saveData.ingredient = ingredientDocData;

  return saveData;
};
